<template>
    <div>
        <div id="scheduleReport" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content schedule-modal">
                    <div class="modal-body text-dark">
                        <h4 class="text-center mb-2">Automated Report Scheduling
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </h4>
                        <div class="form-group mb-2">
                            <label class="text-grey-darkest text-sm" for="email_subject">Email Subject <span class="text-danger">*</span></label>
                            <input type="text" class="p-1 bg-white border-1 focus:outline-none text-grey-darkest text-sm form-control" v-model="scheduleReportForm.subject" name="email_subject" id="email_subject" placeholder="Enter email subject"/>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.subject">{{ scheduleReportErrors.subject }}</span>
                        </div>

                        <div class="form-group mb-2">
                            <label class="text-grey-darkest text-sm">Recipients <span class="text-danger">*</span></label>
                            <multiselect v-model="scheduleReportForm.recipients"
                                         id="recipientEmailSelected"
                                         tag-placeholder="Press enter to add"
                                         placeholder="Add an email"
                                         :options="options"
                                         :multiple="true"
                                         track-by="email"
                                         label="email"
                                         :taggable="true"
                                         :close-on-select="false"
                                         @tag="addRecipient">
                                <template v-slot:noOptions>
                                    <span style="display:none"> List is empty. </span>
                                </template>
                            </multiselect>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.recipients">{{ scheduleReportErrors.recipients }}</span>
                        </div>

                        <div class="form-group mb-2">
                            <label class="text-grey-darkest text-sm"
                                   for="delivery_frequency">Delivery Frequency <span class="text-danger">*</span></label>
                            <select name="delivery_frequency" id="delivery_frequency" v-model="scheduleReportForm.delivery_frequency"
                                    class="p-1 bg-white border-1 focus:outline-none text-grey-darkest text-sm form-control" required @change="frequencyChanged($event)" >
                                <option selected disabled>Select frequency</option>
                                <option value="Daily">Daily</option>
                                <option value="Weekly">Weekly</option>
                                <option value="Monthly">Monthly</option>
                            </select>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.delivery_frequency">{{ scheduleReportErrors.delivery_frequency }}</span>
                        </div>

                        <div class="form-group mb-2 schedule-time-div">
                            <label class="text-grey-darkest text-sm mb-0"
                                   for="scheduled_time">Scheduled Time <span class="text-danger">*</span></label>
                            <p><small>Data is captured up to 2 hours before the email is sent. This is to make sure this email is delivered as on-time as possible.</small></p>
                            <datetime type="time" name="scheduled_time" format="hh:mm a" use12-hour :minute-step="15" required v-model="scheduleReportForm.scheduled_time" id="scheduled_time" class="p-1 bg-white border-1 focus:outline-none text-grey-darkest text-sm form-control"></datetime>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.scheduled_time">{{ scheduleReportErrors.scheduled_time }}</span>
                        </div>

                        <div class="form-group mb-2">
                            <label class="text-grey-darkest text-sm"
                                   for="scheduled_day">Delivery Day <span class="text-danger">*</span></label>
                            <select name="scheduled_day" id="scheduled_day" v-model="scheduleReportForm.scheduled_day"
                                    class="p-1 border-1 focus:outline-none text-grey-darkest text-sm form-control" :disabled="scheduleReportForm.scheduled_day_disabled">
                                <option selected disabled>Select date</option>
                                <option value="monday">Monday</option>
                                <option value="tuesday">Tuesday</option>
                                <option value="wednesday">Wednesday</option>
                                <option value="thursday">Thursday</option>
                                <option value="friday">Friday</option>
                                <option value="saturday">Saturday</option>
                                <option value="sunday">Sunday</option>
                            </select>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.scheduled_day">{{ scheduleReportErrors.scheduled_day }}</span>
                        </div>

                        <div class="form-group mb-2" v-if="selectedReport && selectedReport.id!=='dead-recap' && selectedReport.excel === true && selectedReport.pdf === true">
                            <label class="text-grey-darkest text-sm"
                                   for="report_format">Format <span class="text-danger">*</span></label>
                            <select name="report_format" id="report_format" v-model="scheduleReportForm.report_format"
                                    class="p-1 bg-white border-1 focus:outline-none text-grey-darkest text-sm form-control">
                                <option selected disabled>Select report format</option>
                                <option value="pdf">PDF</option>
                                <option value="excel">Excel</option>
                            </select>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.report_format">{{ scheduleReportErrors.report_format }}</span>
                        </div>

                        <div class="form-group mb-2" v-if="selectedReport && selectedReport.id === 'lead-recap'">
                            <label class="text-grey-darkest text-sm">Lead From <span class="text-danger">*</span></label>
                            <multiselect
                                :options="leadOptions"
                                v-model="scheduleReportForm.selected_leads"
                                :show-labels="false"
                                track-by="id"
                                label="code"
                                group-values="leadOptions"
                                group-label="label"
                                :group-select="true"
                                class="mb-2 cursor-pointer"
                                :multiple="true"
                            > </multiselect>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.selected_leads">{{ scheduleReportErrors.selected_leads }}</span>
                        </div>

                        <div class="text-center mt-4">
                            <button class="btn btn-primary rounded-full" @click="scheduleReport">
                                Schedule Report Email
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mb-4 text-right report-card-btn">
            <button
                class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-3 rounded-full text-followup-nav"
                @click="exportToExcel()" type="button">
                Export To Excel
            </button>

            <button
                class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-3 rounded-full text-followup-nav report-card-schedule-btn"
                @click="scheduleReportCardReport()" type="button"
                data-toggle="tooltip" data-placement="top" title="Apply filter before scheduling the report.">
                Schedule Report
            </button>

            <button
                class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-3 rounded-full text-followup-nav"
                @click="printReportCard" type="button">
                Print
            </button>

            <button
                class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-3 rounded-full text-followup-nav"
                @click="expandAll" type="button">
                Expand All
            </button>

            <button
                class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-3 rounded-full text-followup-nav"
                @click="contractAll" type="button">
                Contract All
            </button>
        </div>
        <h1 class="report-card-heading">Report Card</h1>
        <div class="report-card-div">
            <report-card-row :button="false" first="Bid Date" second="ID" third="Project Quantity" :fourth="getFieldLabel(recordDetailFieldLabels, 'base-bid')"
                             :five="getFieldLabel(recordDetailFieldLabels, 'contract-amount')"></report-card-row>
            <report-card-row :button="bid_volume.numProjects > 0" :yellow="true" :first="`${dateRange.start} to ${dateRange.end}`"
                             second="Bid Volume" :third="bid_volume.numProjects" :fourth="bid_volume.baseBidTotal"
                             :five="bid_volume.contractAmountTotal" class="mb-4">
                <report-card-row v-for="(project, index) in bid_volume.data" :key="index" :button="false"
                                 :white="index % 2 !== 0" :first="project.bid_date" :second="project.custom_project_id ? project.custom_project_id : project.sequential_team_id"
                                 :third="project.name" :fourth="project.base_bid" :five="project.contract_amount"
                                 :project="project.id" :deleted-at="project.deleted_at"></report-card-row>
            </report-card-row>

            <report-card-row :button="false" :first="getFieldLabel(recordDetailFieldLabels, 'contract-date')" second="ID" third="Bid Name" :fourth="getFieldLabel(recordDetailFieldLabels, 'base-bid')"
                             :five="getFieldLabel(recordDetailFieldLabels, 'contract-amount')"></report-card-row>
            <report-card-row :button="contracts_secured.numProjects > 0" :yellow="true" :first="`${dateRange.start} to ${dateRange.end}`"
                             second="Contracts Secured" :third="contracts_secured.numProjects" :fourth="contracts_secured.baseBidTotal"
                             :five="contracts_secured.contractsSecuredTotal" class="mb-4">
                <report-card-row v-for="(project, index) in contracts_secured.data" :key="index" :button="false"
                                 :white="index % 2 !== 0" :first="project.contract_date" :second="project.custom_project_id ? project.custom_project_id : project.sequential_team_id"
                                 :third="project.name" :fourth="project.base_bid" :five="project.contract_amount"
                                 :project="project.id" :deleted-at="project.deleted_at"></report-card-row>
            </report-card-row>


            <report-card-row :button="projects_milestones.numSalesBehaviors > 0" :yellow="true"
                             first="Sales Activities Summary"
                             :fourth="`Total Projects Behavior: ${projects_milestones.grandTotal} Hours`"   class="mb-4">

                <report-card-row :button="false" first="Sales Activity" third="Qty Bids"></report-card-row>
                <report-card-row v-for="(project_milestone_category, index) in projects_milestones.data" :key="index"
                                 :button="true" :first="project_milestone_category.type"
                                 :third="project_milestone_category.numProjects"
                                 :fourth="`Total ${project_milestone_category.total}`">
                    <report-card-row :button="false" first="Date" second="ID" third="Bid Name"
                                     fourth="Credits"></report-card-row>
                    <report-card-row v-for="(project_milestone, index) in project_milestone_category" :key="index"
                                     :button="false" :white="index % 2 === 0" :first="project_milestone.activity_date"
                                     :second="project_milestone.custom_project_id ? project_milestone.custom_project_id : project_milestone.sequential_team_id" :third="project_milestone.project_name"
                                     :fourth="project_milestone.quantity"
                                     :project="project_milestone.project_id" :deleted-at="project_milestone.deleted_at"></report-card-row>
                </report-card-row>
            </report-card-row>

            <report-card-row :button="contact_behaviors.numContactBehaviors > 0 || followup_behaviors.length > 0" :yellow="true"
                             first="Contacts Activities Summary"
                             :fourth="`Total Contacts Behavior: ${contact_behaviors.grandTotal} Hours`"   class="mb-4">

                <report-card-row v-if="followup_behaviors.length > 0" :key="'followupBehaviors'"
                                 :button="true" :first="'Follow Up'"
                                 :third="''"
                                 :fourth="''">
                    <report-card-row :button="false" first="Date" second="ID" third="Contact Name"
                                     fourth=""></report-card-row>
                    <report-card-row v-for="(followup_behavior, index) in followup_behaviors" :key="index"
                                     :button="false" :white="index % 2 === 0" :first="formatDate(followup_behavior.date)"
                                     :second="followup_behavior.contact_id" :third="followup_behavior.contact_name"
                                     :fourth="''"
                                     :contact="followup_behavior.contact_id" :company="followup_behavior.contact_company_id" :deleted-at="followup_behavior.deleted_at"></report-card-row>
                </report-card-row>

                <report-card-row v-for="(contact_milestone_category, index) in contact_behaviors.data" :key="index"
                                 :button="true" :first="contact_milestone_category.type"
                                 :third="contact_milestone_category.numContacts"
                                 :fourth="`Total ${contact_milestone_category.total}`"
                                 v-if="contact_behaviors.numContactBehaviors > 0">
                    <report-card-row :button="false" first="Date" second="ID" third="Contact Name"
                                     fourth="Credits"></report-card-row>
                    <report-card-row v-for="(contact_milestone, index) in contact_milestone_category" :key="index"
                                     :button="false" :white="index % 2 === 0" :first="contact_milestone.activity_date"
                                     :second="contact_milestone.contact_id" :third="contact_milestone.contact_name"
                                     :fourth="contact_milestone.quantity"
                                     :contact="contact_milestone.contact_id" :company="contact_milestone.contact_company_id" :deleted-at="contact_milestone.deleted_at"></report-card-row>
                </report-card-row>

            </report-card-row>
        </div>
    </div>
</template>

<script>
    import ReportCardRow from "./report-card-row";
    import Form from "../../utils/form";
    import Multiselect from "vue-multiselect";
    import Swal from "sweetalert2";

    export default {
        components: {ReportCardRow, Multiselect},
        props     : ['projects_milestones', 'contracts_secured', 'bid_volume', 'masks','contact_behaviors', 'followup_behaviors', 'dateRange', 'recordDetailFieldLabels'],
        data(){
            return {
                scheduleReportForm : new Form({
                    subject: '',
                    recipients:[],
                    delivery_frequency: '',
                    scheduled_time: '',
                    scheduled_day: '',
                    report_id: 'report-card-report',
                    report_name: '',
                    report_format: 'excel',
                    'start-date': '',
                    'end-date': '',
                    user: '',
                    office: '',
                    'contract-type': '',
                    'fixed-date-range-identifier': '',
                    selected_leads : '',
                    scheduled_day_disabled : false,
                }),
                scheduleReportHasError: false,
                scheduleReportErrors: {
                    subject:'',
                    recipients:'',
                    delivery_frequency:'',
                    scheduled_time:'',
                    scheduled_day:'',
                    report_format:'',
                    selected_leads:'',
                },
                options                         : [],
                selectedReport: {
                    excel:true,
                    id:"report-card-report",
                    name:"Report Card Schedule Report",
                    pdf:false

                },
                showSchedule: true,
                reports_exports: [
                    { id: 'report-card-report', name: "Report Card", excel: true, pdf: false },
                ],
            }
        },
        methods: {
            expandAll() {
                let add = document.getElementsByName("plus");
                add.forEach((plus) => {
                    plus.click();
                });
                Vue.nextTick(() => {
                    let add = document.getElementsByName("plus");
                    add.forEach((plus) => {
                        plus.click();
                    });
                });
            },

            contractAll() {
                let subtract = document.getElementsByName("minus");
                subtract.forEach((minus) => {
                    minus.click();
                });
            },

            formatDate(date){
                return moment(date).format('D/M/YYYY')
            },

            printReportCard(){
                this.expandAll();
                setTimeout(() => {
                    window.print();
                    this.contractAll();
                }, 500)
            },

            exportToExcel(){
                let urlParams = new URLSearchParams(window.location.search);
                let data = {
                    startDate: urlParams.get('start-date'),
                    endDate: urlParams.get('end-date'),
                    fixedDateRangeIdentifier: urlParams.get('fixed-date-range-identifier'),
                    user: urlParams.get('user'),
                    contractType: urlParams.get('contract-type'),
                    office: urlParams.get('office')
                }
                axios.post(route('report-card.export'), data).then(response => {
                    this.getToast().fire({
                        type: 'success',
                        title: response.data
                    });
                });
            },

            scheduleReportCardReport(){
                $('#scheduleReport').modal('show');
            },

            openScheduler() {
                if(this.selectedReport)  {
                    this.scheduleReportForm.reset();
                    this.scheduleReportForm.scheduled_day_disabled = false
                    if(this.selectedReport.pdf && !this.selectedReport.excel) {
                        this.scheduleReportForm.report_format = 'pdf'
                    }else if(!this.selectedReport.pdf && this.selectedReport.excel){
                        this.scheduleReportForm.report_format = 'excel'
                    }
                    if(this.selectedReport.id==='dead-recap'){
                        this.scheduleReportForm.report_format = 'pdf'
                    }

                    this.scheduleReportErrors = {
                        subject:'',
                        recipients:'',
                        delivery_frequency:'',
                        scheduled_time:'',
                        scheduled_day:'',
                        report_format:'',
                        selected_leads:'',
                    }
                    $("#scheduleReport").modal("show");
                }
            },

            addRecipient(newEmail) {
                let mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
                if (newEmail.match(mailFormat)) {
                    const tag = {
                        email: newEmail,
                    };
                    this.scheduleReportForm.recipients.push(tag);
                } else {
                    this.fireErrorToast("You have entered an invalid email address!");
                }
            },

            toggleSchedule(val) {
                if(val) {
                    this.showSchedule = true
                }else{
                    this.showSchedule = false
                }
            },

            scheduleReport() {
                this.scheduleReportHasError = false;
                this.scheduleReportForm.report_name = this.selectedReport.name
                this.scheduleReportForm.report_id = this.selectedReport.id
                this.validateField('subject', 'Subject');
                this.validateField('recipients', 'Recipients');
                this.validateField('delivery_frequency', 'Delivery Frequency');
                this.validateField('scheduled_time', 'Scheduled Time');
                if(this.scheduleReportForm.delivery_frequency != "Daily"){
                    this.validateField('scheduled_day', 'Delivery Day');
                }

                if(this.selectedReport.pdf && this.selectedReport.excel) {
                    this.validateField('report_format', 'Format');
                }
                if(this.selectedReport.id === 'lead-recap') {
                    this.validateField('selected_leads', 'Lead From');
                }
                if(this.scheduleReportHasError) {
                    return false
                }
                let urlParams = new URLSearchParams(window.location.search);
                this.scheduleReportForm['start-date'] = urlParams.get('start-date'),
                this.scheduleReportForm['end-date'] = urlParams.get('end-date'),
                this.scheduleReportForm['fixed-date-range-identifier'] = urlParams.get('fixed-date-range-identifier'),
                this.scheduleReportForm.user = urlParams.get('user'),
                this.scheduleReportForm['contract-type'] = urlParams.get('contract-type'),
                this.scheduleReportForm.office = urlParams.get('office')

                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000
                });
                axios.post(route('api.schedule-report.store'), this.scheduleReportForm).then(response => {
                    if (response.data.status) {
                        Toast.fire({
                            type: "success",
                            title: response.data.message
                        });
                        this.scheduleReportForm.reset();
                        $("#scheduleReport").modal("hide");
                    } else {
                        Toast.fire({
                            type: "error",
                            title: response.data.message
                        });
                    }
                }).catch((error) => {
                    console.log('error', error);
                })
            },

            validateField(fieldName, fieldLabel) {
                if(fieldName === 'recipients') {
                    if(this.scheduleReportForm[fieldName].length === 0) {
                        this.scheduleReportErrors[fieldName] = fieldLabel+' is required'
                        this.scheduleReportHasError = true
                    }
                }else if(fieldName === 'selected_leads') {
                    if(this.scheduleReportForm[fieldName].length === 0) {
                        this.scheduleReportErrors[fieldName] = fieldLabel+' is required'
                        this.scheduleReportHasError = true
                    }
                }else{
                    if(!this.scheduleReportForm[fieldName].trim()) {
                        this.scheduleReportErrors[fieldName] = fieldLabel+' is required'
                        this.scheduleReportHasError = true
                    }
                }

            },

            frequencyChanged(event) {
                console.log(event.target.value)
                if(event.target.value === "Daily") {
                    this.scheduleReportForm.scheduled_day_disabled = true
                }else {
                    this.scheduleReportForm.scheduled_day_disabled = false
                }
            },

            getValue(report){
                return {
                    id: report.id,
                    name: report.name,
                    excel: report.excel,
                    pdf: report.pdf ?? null
                }
            },

        },
        watch: {
            scheduleReportForm: {
                immediate: false,
                handler: function (scheduleValue, oldVal) {
                    if(scheduleValue.subject!==""){
                        this.scheduleReportErrors.subject='';
                        this.scheduleReportHasError = false
                    }
                    if(scheduleValue.recipients.length > 0){
                        this.scheduleReportErrors.recipients='';
                        this.scheduleReportHasError = false
                    }
                    if(scheduleValue.delivery_frequency!==""){
                        this.scheduleReportErrors.delivery_frequency='';
                        this.scheduleReportHasError = false
                    }
                    if(scheduleValue.scheduled_time!==""){
                        this.scheduleReportErrors.scheduled_time='';
                        this.scheduleReportHasError = false
                    }
                    if(scheduleValue.scheduled_day!==""){
                        this.scheduleReportErrors.scheduled_day='';
                        this.scheduleReportHasError = false
                    }
                    if(scheduleValue.report_format!==""){
                        this.scheduleReportErrors.report_format='';
                        this.scheduleReportHasError = false
                    }
                },
                deep: true
            },
        },
        mounted(){
            $(function () {
                $(".report-card-schedule-btn").tooltip();
            });
        }
    }
</script>
<style>
.report-card-heading{
    display: none;
}
@media print{
    .navbar,
    .report-card-filter-div,
    .report-card-btn{
        display:none;
    }
    .report-card-heading{
        display: block;
    }
    * {
        -webkit-print-color-adjust: exact !important;   /* Chrome, Safari 6 – 15.3, Edge */
        color-adjust: exact !important;                 /* Firefox 48 – 96 */
        print-color-adjust: exact !important;           /* Firefox 97+, Safari 15.4+ */
    }
}
.schedule-time-div input.vdatetime-input {
    width: 100%;
    height: 100%;
}
</style>
